import lang from 'lang'
import settingsConfig from 'settings/config'
import request from '@/modules/base/util/request'
import { merge, clone } from 'lodash'

import { toast } from '@/modules/base/components/toast/toastConfig'

// actions
const SHOW_LOADER = 'settings/extensions/SHOW_LOADER'
const HIDE_LOADER = 'settings/extensions/HIDE_LOADER'
const SHOW_MODAL_LOADER = 'settings/extensions/SHOW_MODAL_LOADER'
const HIDE_MODAL_LOADER = 'settings/extensions/HIDE_MODAL_LOADER'
const OPEN_FORM_MODAL = 'settings/extensions/OPEN_FORM_MODAL'
const CLOSE_FORM_MODAL = 'settings/extensions/CLOSE_FORM_MODAL'
const SET_EXTENTIONS = 'settings/extensions/SET_EXTENTIONS'

// reducer
const initialState = {
  isLoading: false,
  formModalOpen: false,
  isModalLoading: false,
  conditions: [],
  selectedExtension: undefined,
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SHOW_LOADER:
      return { ...state, isLoading: true }

    case HIDE_LOADER:
      return { ...state, isLoading: false }

    case SHOW_MODAL_LOADER:
      return { ...state, isModalLoading: true }

    case HIDE_MODAL_LOADER:
      return { ...state, isModalLoading: false }

    case OPEN_FORM_MODAL:
      const { selectedExtension } = action
      return { ...state, formModalOpen: true, selectedExtension }

    case CLOSE_FORM_MODAL:
      return { ...state, formModalOpen: false, selectedExtension: undefined }

    case SET_EXTENTIONS:
      const { data } = action
      return { ...state, ...data }

    default:
      return state
  }
};

// action creators
const showLoader = () => {
  return {
    type: SHOW_LOADER,
  }
}

const hideLoader = () => {
  return {
    type: HIDE_LOADER,
  }
}

const showModalLoader = () => {
  return {
    type: SHOW_MODAL_LOADER,
  }
}

const hideModalLoader = () => {
  return {
    type: HIDE_MODAL_LOADER,
  }
}

export const openFormModal = (extension) => ({
  type: OPEN_FORM_MODAL,
  selectedExtension: extension,
})

export const closeFormModal = () => ({
  type: CLOSE_FORM_MODAL,
})

const setExtensions = (data) => {
  return {
    type: SET_EXTENTIONS,
    data,
  }
}

export const fetchExtensions = () => {
  return (dispatch) => {
    dispatch(showLoader())
    request(settingsConfig.extensions, { auth: true, method: 'GET', isConcurrent: true })
      .then((response) => {
        const { body: { data: extensions } } = response
        dispatch(setExtensions({ extensions }))
        dispatch(hideLoader())
      })
      .catch(() => {
        dispatch(hideLoader())
      })
  }
}

export const updateExtension = (id, data) => {
  return (dispatch, getState) => {
    dispatch(showModalLoader())
    const { settings: { extensions: { extensions } } } = getState()

    const requests = [
      request(`${settingsConfig.extensions}/${id}`, { auth: true, method: 'PUT', data }),
    ]

    Promise.all(requests)
      .then(() => {
        const updatedExtensions = extensions.map(extension => {
          if (extension.id === id) {
            const extensionUpdate = clone(extension)
            const { tenantSettings } = extension
            merge(tenantSettings, data)
            return extensionUpdate
          }
          return extension
        })

        dispatch(setExtensions({ extensions: updatedExtensions }))
        dispatch(closeFormModal())
        toast.showToast({ message: lang.extensionsSaveSuccessMessage })
      })
      .catch(() => {
        toast.showToast({ message: lang.defaultErrorMessage, type: 'error' })
      })
      .finally(() => dispatch(hideModalLoader()))
  }
}
